import React, { useEffect, useState } from 'react';

import { fetchManualAttachmentUrl } from 'src/api/adminManualTransactions';

import { AttachmentFallback, AttachmentThumb } from './styled';

type AttachmentImageProps = {
  transactionId: string;
  attachmentId: string;
  index: number;
};

/**
 * The attachment endpoint streams the image behind the admin token, so it is
 * fetched as a blob rather than pointed at with an `<img src>`.
 */
const AttachmentImage: React.FC<AttachmentImageProps> = ({
  transactionId,
  attachmentId,
  index,
}) => {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    let active = true;

    fetchManualAttachmentUrl(transactionId, attachmentId)
      .then((next) => {
        objectUrl = next;
        if (active) setUrl(next);
        else URL.revokeObjectURL(next);
      })
      .catch(() => {
        if (active) setFailed(true);
      });

    return () => {
      active = false;
      // The blob would otherwise be held for the life of the document.
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [transactionId, attachmentId]);

  if (failed) {
    return <AttachmentFallback>Could not load</AttachmentFallback>;
  }

  if (!url) {
    return <AttachmentFallback>Loading…</AttachmentFallback>;
  }

  return (
    <AttachmentThumb href={url} target="_blank" rel="noreferrer noopener" title="Open full size">
      <img src={url} alt={`Attachment ${index + 1}`} />
    </AttachmentThumb>
  );
};

export default AttachmentImage;
